/* eslint-disable react/no-unknown-property */
import { object, array } from "prop-types";
import { WithLazy, Link } from "@quintype/components";
import { useSelector } from "react-redux";
import get from "lodash/get";
import React, { useEffect } from "react";

import { ArrowOpinionCollection, ArrowTwoColSevenStories } from "../../collection-templates/arrow-rows";
import { DfpComponent } from "../../ads/dfp-component";
import { getAdSlots } from "../../ads/utils";
import AuthorInfo from "../../molecules/story-page-items/story-info/author-info";
import Breadcrumbs from "../../molecules/story-page-items/story-info/bread-crumbs";
import HeroImage from "../../molecules/story-page-items/story-info/hero-image";
import ReadMoreStories from "../../molecules/story-page-items/read-more-stories";
import SlideshowElement from "../../molecules/story-page-items/custom-story-elements/slideshow-element";
import StoryDate from "../../molecules/story-page-items/story-info/story-date";
import StoryMetaIcons from "../../molecules/story-page-items/story-info/story-meta-icons";
import { OldStoryMessage } from "../../atoms/old-stories-message";

import "./gallery-story.m.css";

const GalleryStory = ({ story, collection, galleryCollection }) => {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const adsConfig = get(qtState, ["config", "ads-config"], {});
  const enableAds = get(adsConfig, ["dfp_ads", "enable_ads"]);
  const adConfig = get(adsConfig, ["slots", "story_page_ads"], {});
  const loadAdsSynchronously = get(adsConfig, ["dfp_ads", "load_ads_synchronously"], null);
  const firstElement =
    story &&
    story.cards[0]["story-elements"].find(
      ({ metadata, subtype }) => metadata.type === "slideshow" && subtype === "image-gallery"
    );
  const adSlots = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots"], {}));
  const lang = useSelector((state) => get(state, ["qt", "config", "publisher-attributes", "lang"], "en"));
  const enableGoogleAds = get(story, ["metadata", "story-attributes", "enablegoogleads", "0"], "true");

  useEffect(() => {
    if (enableAds) {
      const sectionSlug = get(story, ["sections", 0, "slug"], "NA");
      getAdSlots({
        path: adConfig.ad_unit,
        size: adConfig.sizes,
        id: `story-card-${story.id}-ad`,
        qtState,
        viewPortSizeMapping: adConfig.view_port_size_mapping,
        storySectionSlug: sectionSlug,
        refreshAdUnit: true,
        loadAdsSynchronously,
        delayPeriod: 4000,
      });
    }
  }, [story]);

  return (
    <div className="story-grid">
      <div className="container" styleName="photo-story-wrapper">
        <div styleName="hero-image-wrapper" data-test-id="hero-image-wrapper">
          <Breadcrumbs story={story} />
          <h2 styleName="headline">{story.headline}</h2>
          {story.subheadline && <h3 styleName="sub-headline">{story.subheadline}</h3>}
          {enableGoogleAds === "true" && (
            <DfpComponent
              adStyleName="ad-slot-size-300x100-leaderboard"
              className="ad-slot-size-300x100-leaderboard mobile-ad"
              id="story-leader-board-2-mobile"
              path={adSlots.story_leader__ad2.ad_unit}
              size={adSlots.story_leader__ad2.sizes}
              viewPortSizeMapping={adSlots.story_leader__ad2.view_port_size_mapping}
            />
          )}
          {firstElement ? (
            <WithLazy margin="50px">
              {() => (
                <div styleName="element-wrapper">
                  <SlideshowElement story={story} element={firstElement} />
                </div>
              )}
            </WithLazy>
          ) : (
            <HeroImage story={story} />
          )}
        </div>
        <AuthorInfo story={story} />
        <StoryDate story={story} />
        <StoryMetaIcons story={story} />
        {enableGoogleAds === "true" && (
          <DfpComponent
            adStyleName={lang === "bn" ? "ad-slot-size-300x100" : "ad-slot-size-300x250-leaderboard"}
            className={lang === "bn" ? "ad-slot-size-300x100" : "ad-slot-size-300x250-leaderboard"}
            id="story-leader-board-2"
            path={adSlots.story_leader_below_hero.ad_unit}
            size={adSlots.story_leader_below_hero.sizes}
            viewPortSizeMapping={adSlots.story_leader_below_hero.view_port_size_mapping}
          />
        )}
        {story.tags.length > 0 && (
          <div styleName="tags-wrapper">
            {story.tags.map((tag, index) => (
              <Link href={"/topic/" + tag.slug} key={index}>
                <div styleName="tag">{tag.name}</div>
              </Link>
            ))}
          </div>
        )}
        <OldStoryMessage story={story} />
        {enableGoogleAds === "true" && (
          <DfpComponent
            adStyleName="ad-slot-size-970x90"
            className="ad-slot-size-970x90"
            id="story-leader-board-3"
            path={adSlots.story_leader__ad3.ad_unit}
            size={adSlots.story_leader__ad3.sizes}
            viewPortSizeMapping={adSlots.story_leader__ad3.view_port_size_mapping}
          />
        )}
        {galleryCollection && (
          <div styleName="gallery-wrapper">
            <ArrowTwoColSevenStories collection={galleryCollection} />
          </div>
        )}
        <div id="metype-commenting-widget"></div>
        <ReadMoreStories />
        {collection && (
          <div styleName="opinion-wrapper">
            <ArrowOpinionCollection collection={collection} />
          </div>
        )}
      </div>
    </div>
  );
};

GalleryStory.propTypes = {
  story: object,
  relatedStories: array,
  collection: object,
  card: object,
  galleryCollection: object,
};

export { GalleryStory };
